export const NhomSelectData = [
  { value: "Nhóm 01", label: "Nhóm 01" },
  { value: "Nhóm 02", label: "Nhóm 02" },
  { value: "Nhóm 03", label: "Nhóm 03" },
  { value: "Nhóm 04", label: "Nhóm 04" },
  { value: "Nhóm 05", label: "Nhóm 05" },
  { value: "Nhóm 06", label: "Nhóm 06" },
  { value: "Nhóm 07", label: "Nhóm 07" },
  { value: "Nhóm 08", label: "Nhóm 08" },
  { value: "Nhóm 09", label: "Nhóm 09" },
  { value: "Nhóm 10", label: "Nhóm 10" },
  { value: "Nhóm 11", label: "Nhóm 11" },
  { value: "Nhóm 12", label: "Nhóm 12" },
  { value: "Nhóm 13", label: "Nhóm 13" },
  { value: "Nhóm 14", label: "Nhóm 14" },
  { value: "Nhóm 15", label: "Nhóm 15" },
  { value: "Nhóm 16", label: "Nhóm 16" },
  { value: "Nhóm 17", label: "Nhóm 17" },
  { value: "Nhóm 18", label: "Nhóm 18" },
  { value: "Nhóm 19", label: "Nhóm 19" },
  { value: "Nhóm 20", label: "Nhóm 20" },
  { value: "Nhóm 21", label: "Nhóm 21" },
  { value: "Nhóm 22", label: "Nhóm 22" },
  { value: "Nhóm 23", label: "Nhóm 23" },
  { value: "Nhóm 24", label: "Nhóm 24" },
  { value: "Nhóm 25", label: "Nhóm 25" },
  { value: "Nhóm 26", label: "Nhóm 26" },
  { value: "Nhóm 27", label: "Nhóm 27" },
  { value: "Nhóm 28", label: "Nhóm 28" },
  { value: "Nhóm 29", label: "Nhóm 29" },
  { value: "Nhóm 30", label: "Nhóm 30" },
  { value: "Nhóm 31", label: "Nhóm 31" },
  { value: "Nhóm 32", label: "Nhóm 32" },
  { value: "Nhóm 33", label: "Nhóm 33" },
  { value: "Nhóm 34", label: "Nhóm 34" },
  { value: "Nhóm 35", label: "Nhóm 35" },
  { value: "Nhóm 36", label: "Nhóm 36" },
  { value: "Nhóm 37", label: "Nhóm 37" },
  { value: "Nhóm 38", label: "Nhóm 38" },
  { value: "Nhóm 39", label: "Nhóm 39" },
  { value: "Nhóm 40", label: "Nhóm 40" },
  { value: "Nhóm 41", label: "Nhóm 41" },
  { value: "Nhóm 42", label: "Nhóm 42" },
  { value: "Nhóm 43", label: "Nhóm 43" },
  { value: "Nhóm 44", label: "Nhóm 44" },
  { value: "Nhóm 45", label: "Nhóm 45" },
];
